export * from './component';



// WEBPACK FOOTER //
// ./src/components/news-and-events/commonPageHeader/index.js